<template>
    <!-- Требуемые действия -->
    <div class="scrollable-table-container">
        <div class="notifications-block">
            <!-- Блок с уведомлениями с типом "Требуется действие". 
            Уведомления должны выводиться отсортированные по дате 
            возникновения от новых к старым. Закрепленные уведомления 
            должны выводиться в верхней части блока по дате возникновения 
            от новых к старым  -->
            <NotificationBlock
                :data="securedData"
                :secured="true"
                @unSecureNotification="unSecureNotification"
                @openOrder="openOrder"
            ></NotificationBlock>
            <NotificationBlock
                :data="data"
                :secured="false"
                @secureNotification="secureNotification"
                @openOrder="openOrder"
            ></NotificationBlock>
        </div>
    </div>
</template>

<script>
import NotificationBlock from "./NotificationBlock.vue";
export default {
    name: 'NotificationsComponent',
    components: {
        NotificationBlock
    },
    data() {
        return {
            data: [], 
            securedData: [], // закрепленные
        }
    },
    mounted() {
        this.init();
    },
    watch: {
        securedData(newVal, oldVal) {
            this.securedData.sort((a, b) => b.date - a.date);
            console.log(newVal);
            console.log(oldVal);
        },
        data() {
            this.data.sort((a, b) => b.date - a.date);
        },
    },
    methods: {
        // Инициализация
        init() {
            // заполнить data уведомлениями по запросу
            this.data = [
                {
                    id: 0,
                    notification: "Требуется согласование по заказу №123456", 
                    date: "13.11.2023 9:30", 
                    status: "В работе"
                },
                {
                    id: 1,
                    notification: "Требуется согласование по заказу №123457", 
                    date: "14.11.2023 9:28", 
                    status: "В работе"
                },
                {
                    id: 2,
                    notification: "Требуется согласование по заказу №123434", 
                    date: "09.12.2023 9:28", 
                    status: "В работе"
                },
                {
                    id: 3,
                    notification: "Требуется согласование по заказу №123411", 
                    date: "24.10.2023 9:28", 
                    status: "В работе"
                },
            ],
            this.securedData = [
                {
                    id: 4,
                    notification: "Требуется согласование по заказу №123456", 
                    date: "13.11.2023 9:30", 
                    status: "В работе"
                },
            ],
            // Сортировка по убыванию
            this.data.sort((a, b) => b.date - a.date);
        },

        // Закрепить уведомления
        secureNotification(notificationObj) {
            // let editSecuredData = this.securedData
            // console.log(editSecuredData)
            // добавить в массив закрепоенных уведомлений
            this.securedData.push(notificationObj);
            this.securedData.sort((a, b) => b.date - a.date);
            // this.securedData = editSecuredData
            
            // Удалить из основного массива
            let index = this.data.findIndex(item => item.notification === notificationObj.notification);
            if (index !== -1) {
                this.data.splice(index, 1);
                this.data.sort((a, b) => b.date - a.date);
            }
        },

        // Открепить уведомления
        unSecureNotification(notificationObj) {
            // let editData = this.data
            // добавить в основной массив
            this.data.push(notificationObj);
            this.data.sort((a, b) => b.date - a.date);
            // this.data = editData

            // Удалить из массива закрепленных
            let index = this.securedData.findIndex(item => item.notification === notificationObj.notification);
            if (index !== -1) {
                this.securedData.splice(index, 1);
                this.securedData.sort((a, b) => b.date - a.date);
            }
            
        },

        // Открепить заказ в новой вкладке
        openOrder(notificationObj) {
            alert("Открытие страницы уведомления")
            console.log(notificationObj)
        }
        
    }
}
</script>